export interface IRedirectOption {
  text: string;
  status: number;
}

export const DOMAIN_PURESPECTRUM = 'purespectrum.com';
export const DOMAIN_SPECTRUM_SURVEYS = 'spectrumsurveys.com';
export const ENV_QA_PATTERN = /qa(\d+)/;
export const ENV_QA_API_URL = (n: string) =>
  `https://qa${n}-api.spectrumsurveys.com`;
export const ENV_STAGING_URL = 'https://staging.spectrumsurveys.com';

export const MP_REDIRECT_OPTIONS: IRedirectOption[] = [
  { text: 'Complete', status: 21 },
  { text: 'Buyer_QuotaFull', status: 17 },
  { text: 'Buyer_Termination', status: 18 },
  { text: 'Buyer_Drop', status: 19 },
  { text: 'Buyer_Quality_Termination', status: 20 },
  { text: 'Buyer_Security', status: 30 },
];
